<!-- 下拉组件 -->
<template>
  <div class="select-module">
    <a-select
      :placeholder="placeholder"
      :value="targetValue"
      :mode="mode ? mode : 'default'"
      :disabled="disabled"
      :notFoundContent="notFoundContent"
      @change="handleChange"
      :getPopupContainer="getPopupContainer"
    >
      <a-select-option
        value
        :parameter="{}"
        v-if="mode != 'multiple' && !showAll"
        >{{ isAllShow }}</a-select-option
      >
      <a-select-option
        :value="item.id"
        v-for="item in selectOptionData"
        :key="item.id"
        :disabled="item.disabled"
        :parameter="item || {}"
        >{{ item.name }}</a-select-option
      >
    </a-select>
  </div>
</template>

<script>
import SELECTAPI from "@/api/select.js";

export default {
  name: "SelectModule",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: String | Number | Array,
    // 不同分类的下拉
    selectData: {
      type: Array,
      required: false,
    },
    // 默认选项
    isAllShow: {
      type: String,
      required: false,
      default: "全部",
    },
    // 是否显示全部
    showAll: {
      type: Boolean,
      required: false,
      default: false,
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    // 设置 Select 的模式为多选或标签
    mode: {
      type: String,
      required: false,
    },
    // 接口名称
    apiType: {
      type: String,
      required: false,
    },
    // 接口传参
    apiParams: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
    // 需要过滤的数据
    filter: {
      type: Array,
      required: false,
    },
    // 菜单渲染父节点
    popupContainer: {
      type: String,
      required: false,
    },
    // 选择框默认文字
    placeholder: {
      type: String,
      required: false,
      default: "请选择",
    },
    autoLabel: {
      type: String,
      required: false,
      default: "name",
    },
    autoValue: {
      type: String,
      required: false,
      default: "id",
    },
    notFoundContent: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      selectOptionData: [], // 下拉列表数据
    };
  },
  computed: {
    // 当前选中业态的值
    targetValue: {
      get: function (val) {
        return this.value || "";
      },
      set: function (val) {
        this.handleChange(val);
      },
    },
  },
  mounted() {
    // 从接口获取下拉列表数据
    if (!this.selectData) {
      this.getSelectOption();
    }
  },
  methods: {
    // 获取菜单渲染父节点
    getPopupContainer(trigger) {
      if (this.popupContainer == "body") {
        // 相对body定位
        return document.body;
      } else {
        // 相对父级节点定位
        return trigger.parentNode;
      }
    },
    // 联想下拉选中
    handleChange(id, option) {
      if (this.mode != "multiple") {
        let obj = {
          id: "",
          name: "",
        };
        if (id) {
          let data = option.data.attrs.parameter;
          obj = data;
        }
        this.$emit("change", id, obj);
      } else {
        this.$emit("change", id, option);
      }
    },
    // 获取下拉列表数据
    getSelectOption() {
      if (!this.apiType) return; // 没有接口
      const params = !this.apiParams ? {} : this.apiParams;
      let paramsObj = {
        data: {
          params: {
            ...params,
          },
        },
      };
      SELECTAPI[this.apiType](paramsObj, (callback) => {
        let list = [];
        if (callback.status == "S" && callback.data) {
          if (Array.isArray(callback.data) && callback.data.length > 0) {
            callback.data.map((item, index) => {
              list.push({
                id: item[this.autoValue],
                name: item[this.autoLabel],
              });
            });
          }
        }
        this.selectOptionData = list;
        this.$emit("callBack", list);
      });
    },
  },
  watch: {
    selectData: {
      handler(newVal, oldVal) {
        if (Array.isArray(newVal)) {
          this.selectOptionData = newVal || [];
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="less">
.select-module {
  width: 100%;
  position: relative;
}
</style>
